<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row mb-4">
      <div class="col-12">
        <div class="float-left">
          <div class="input-group input-group-sm">
            <label class="mr-2">Dashboard date range</label>
            <select
              v-model="dateSelected"
              @change="changeDateSelection"
              class="custom-select custom-select-sm"
            >
              <option value="month">Monthly</option>
              <option value="year">Year to date</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-4">
        <!-- <Profile class="comingSoon"/> -->
        <!-- old -->
        <!-- v-if="loadedFlag && !Number.isNaN(Number(earningsDifference))" -->
        <!-- new -->
        <!-- :loading="!loadedFlag && !Number.isNaN(Number(earningsDifference))" -->

        <!-- :difference="Number(earningsDifference)" -->
        <Earning
          :key="earningsKey"
          v-if="loadedFlag && !Number.isNaN(Number(earningsDifference))"
          :month="earningsMonth"
          :timespan="dateSelected"
          :total="earningsTotal.toFixed(2)"
          :chartColor="earningsDifference >= 1 ? '#556ee6' : '#f46a6a'"
          :billableTimes="billableTimes"
          :billableProducts="billableProducts"
          :billableProcurements="billableProcurements"
          :fixedRateJobRevenue="fixedRateJobRevenue"
          :fixedRateJobs="fixedRateJobs"
          ref="chart_homepageRevenue"
        />
        <div class="card">
          <div
            class="card-body"
            v-show="!loadedFlag && !Number.isNaN(Number(earningsDifference))"
          >
            <h4 class="card-title mb-2" style="text-transform: capitalize">
              Loading...
            </h4>
            <div class="row">
              <div>
                <i
                  class="spinner-border text-primary m-1"
                  role="status"
                  id="spinner"
                ></i>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-2">Top Jobs By Revenue</h4>
            <p class="text-muted">{{ earningsMonth }}</p>

            <div class="text-center">
              <div v-if="topJobsEarnings.length >= 1" class="mb-4">
                <i class="bx bx-dollar-circle text-primary display-4"></i>
              </div>
              <h3 v-if="topJobsEarnings.length >= 1">
                ${{
                  topJobsEarnings.length >= 1
                    ? topJobsEarnings[0].total.toFixed(2)
                    : 0
                }}
              </h3>
              <p v-if="topJobsEarnings.length >= 1">
                Job:
                {{
                  topJobsEarnings.length >= 1 ? topJobsEarnings[0].jobNum : ''
                }}
              </p>
              <p v-if="topJobsEarnings.length >= 1">
                Customer:
                {{
                  topJobsEarnings.length >= 1 ? topJobsEarnings[0].customer : ''
                }}
              </p>
              <h3 v-if="topJobsEarnings.length == 0">
                No times for {{ earningsMonth }}
              </h3>
            </div>

            <div class="table-responsive mt-4">
              <table class="table table-centered">
                <tbody>
                  <tr
                    class="topJobsHomepage"
                    v-for="job in topJobsEarnings.slice(0, 3)"
                    :key="job.index"
                    @click="goToJob(job.jobNum)"
                  >
                    <td style="width: 140px">
                      <p class="mb-0">
                        <strong>{{ job.jobNum }}</strong>
                      </p>
                      <p class="mb-0">{{ job.customer }}</p>
                    </td>
                    <td style="width: 120px">
                      <h5 class="mb-0">${{ job.total.toFixed(2) }}</h5>
                    </td>
                    <td>
                      <b-progress
                        :value="(job.total / topJobsEarnings[0].total) * 100"
                        variant="primary"
                        height="5px"
                      ></b-progress>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
      <div class="col-xl-8">
        <div class="row">
          <div class="col-md-3">
            <Stat
              :icon="'bx bx-copy-alt'"
              :title="'Total Hours'"
              :subTitle="`This ${dateSelected}`"
              :value="totalHours.toFixed(2) + 'hrs.'"
            />
          </div>
          <div class="col-md-3">
            <Stat
              :icon="'bx bx-copy-alt'"
              :title="'Average Hours Per Day'"
              :subTitle="`This ${dateSelected}`"
              :value="averageHours + 'hrs.'"
            />
          </div>
          <div class="col-md-3">
            <Stat
              :icon="'bx bx-copy-alt'"
              :title="'New Jobs'"
              :subTitle="'This week'"
              :value="newJobs"
            />
          </div>
          <div class="col-md-3">
            <Stat
              :icon="'bx bx-copy-alt'"
              :title="'Remaining Amount to be Invoiced'"
              :value="`
                $${(
                  jobsWithInvoiceCalculationsTotals.revenue -
                  jobsWithInvoiceCalculationsTotals.invoiced
                ).toFixed(2)}`"
            />
          </div>

          <div class="col-xl-12">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-5">Recent Activity</h4>
                <ul class="verti-timeline list-unstyled">
                  <li
                    v-for="(time, index) in recentTimes"
                    :key="index"
                    class="event-list"
                    @click="goToJob(time.jobNum)"
                  >
                    <div class="event-timeline-dot">
                      <i class="bx bx-right-arrow-circle font-size-18"></i>
                    </div>
                    <div class="media">
                      <div class="mr-3">
                        <h5 class="font-size-14">
                          {{ time.date }}
                          <br />
                          {{ time.employee }}
                          <i
                            class="bx bx-radio-circle font-size-16 text-primary align-middle ml-2"
                          ></i>
                          {{ time.hours }}hrs.
                          <i
                            class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                          ></i>
                        </h5>
                      </div>
                      <div class="media-body">
                        <div>{{ time.description }}</div>
                      </div>
                    </div>
                  </li>
                  <!-- <li class="event-list">
                    <div class="event-timeline-dot">
                      <i class="bx bx-right-arrow-circle font-size-18"></i>
                    </div>
                    <div class="media">
                      <div class="mr-3">
                        <h5 class="font-size-14">
                          22 Nov
                          <i
                            class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                          ></i>
                        </h5>
                      </div>
                      <div class="media-body">
                        <div>Responded to need “Volunteer Activities</div>
                      </div>
                    </div>
                  </li>
                  <li class="event-list">
                    <div class="event-timeline-dot">
                      <i class="bx bx-right-arrow-circle font-size-18"></i>
                    </div>
                    <div class="media">
                      <div class="mr-3">
                        <h5 class="font-size-14">
                          17 Nov
                          <i
                            class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                          ></i>
                        </h5>
                      </div>
                      <div class="media-body">
                        <div>
                          Everyone realizes why a new common language would be desirable...
                          <a
                            href="javascript: void(0);"
                          >Read more</a>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="event-list active">
                    <div class="event-timeline-dot">
                      <i class="bx bxs-right-arrow-circle font-size-18 bx-fade-right"></i>
                    </div>
                    <div class="media">
                      <div class="mr-3">
                        <h5 class="font-size-14">
                          15 Nov
                          <i
                            class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                          ></i>
                        </h5>
                      </div>
                      <div class="media-body">
                        <div>Joined the group “Boardsmanship Forum”</div>
                      </div>
                    </div>
                  </li>
                  <li class="event-list">
                    <div class="event-timeline-dot">
                      <i class="bx bx-right-arrow-circle font-size-18"></i>
                    </div>
                    <div class="media">
                      <div class="mr-3">
                        <h5 class="font-size-14">
                          12 Nov
                          <i
                            class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                          ></i>
                        </h5>
                      </div>
                      <div class="media-body">
                        <div>Responded to need “In-Kind Opportunity”</div>
                      </div>
                    </div>
                  </li> -->
                </ul>
                <!-- <div class="text-center mt-4">
                  <a href="javascript: void(0);" class="btn btn-primary btn-sm">Load More</a>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <div
      class="d-none"
      v-for="(job, index) in jobsWithInvoiceCalculations"
      v-bind:key="index"
    >
      <RevenueChart
        v-if="!loadingJobSpecificData"
        :jobNum="job.jobNum"
        :allTimes="job.times"
        :allProducts="job.products"
        :jobType="job.jobType"
        :jobQuote="job.jobQuote"
        @revenueCalculated="revenueCalculated"
      ></RevenueChart>
    </div>

    <!-- <button class="btn btn-primary btn-sm" @click="testSendBillingReport">
      Send Billing Report
    </button> -->
    <!-- <button class="btn btn-success btn-sm" @click="testSendWeeklyWorkOrderReport"> Send Weekly Work Order Report</button> -->

    <!-- <div class="row">
      <div class="col-lg-12">
        <div class="card comingSoon">
          <div class="card-body">
            <h4 class="card-title mb-4">Latest Transaction</h4>
            <Transaction :transactions="transactions" />
          </div>
        </div>
      </div>
    </div> -->
    <!-- end row -->
  </Layout>
</template>

<script>
import Vue from 'vue';
import Layout from '../../layouts/main';
import appConfig from '@/app.config';
import PageHeader from '@/components/page-header';
// import axios from 'axios';

// import Profile from "@/components/widgets/profile";
import Earning from '@/components/widgets/earning';
import Stat from '@/components/widgets/stat';
import RevenueChart from '@/router/views/production/components/jobs/RevenueChart.vue';

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);
// import Transaction from "@/components/widgets/transaction";

import { firestore } from 'firebase';
import moment from 'moment';

export default {
  page: {
    name: 'home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    RevenueChart,
    // Profile,
    Stat,
    // Transaction,
    Earning,
  },
  data() {
    return {
      title: 'Dashboard',
      items: [
        {
          text: 'Dashboard',
          href: '/',
          active: true,
        },
      ],
      recentTimes: [],
      earningsMonth: moment().format('MMMM'),
      earningsTotal: 0,
      sumHoursTotal: 0,
      earningsDifference: 0,
      allTimes: [],
      allJobs: [],
      allProducts: [],
      allProcurements: [],
      billableProducts: [],
      billableTimes: [],
      billableProcurements: [],
      topJobsEarnings: [],
      loadedFlag: false,
      totalHours: 0,
      averageHours: 0,
      newJobs: 0,
      jobTypesCollection: [],
      earningsKey: 0,
      fixedRateJobRevenue: 0,
      fixedRateJobs: [],
      jobsWithInvoiceCalculations: [],
      jobsWithInvoiceCalculationsTotals: {
        revenue: 0,
        invoiced: 0,
      },
      loadingJobSpecificData: true,
      dateSelected: 'month',
      // transactions: [
      //   {
      //     id: '#SK2540',
      //     name: 'Neal Matthews',
      //     date: '07 Oct, 2019',
      //     total: '$400',
      //     status: 'Paid',
      //     payment: ['fa-cc-mastercard', 'Mastercard'],
      //     index: 1,
      //   },
      //   {
      //     id: '#SK2541',
      //     name: 'Jamal Burnett',
      //     date: '07 Oct, 2019',
      //     total: '$380',
      //     status: 'Chargeback',
      //     payment: ['fa-cc-visa', 'Visa'],
      //     index: 2,
      //   },
      //   {
      //     id: '#SK2542',
      //     name: 'Juan Mitchell',
      //     date: '06 Oct, 2019',
      //     total: '$384',
      //     status: 'Paid',
      //     payment: ['fab fa-cc-paypal', 'Paypal'],
      //     index: 3,
      //   },
      //   {
      //     id: '#SK2543',
      //     name: 'Barry Dick',
      //     date: '05 Oct, 2019',
      //     total: '$412',
      //     status: 'Paid',
      //     payment: ['fa-cc-mastercard', 'Mastercard'],
      //     index: 4,
      //   },
      //   {
      //     id: '#SK2544',
      //     name: 'Ronald Taylor',
      //     date: '04 Oct, 2019',
      //     total: '$404',
      //     status: 'Refund',
      //     payment: ['fa-cc-visa', 'Visa'],
      //     index: 5,
      //   },
      //   {
      //     id: '#SK2545',
      //     name: 'Jacob Hunter',
      //     date: '04 Oct, 2019',
      //     total: '$392',
      //     status: 'Paid',
      //     payment: ['fab fa-cc-paypal', 'Paypal'],
      //     index: 6,
      //   },
      // ],
    };
  },
  methods: {
    //these are the times in the card labelled "Recent activity"
    getRecentTimes: function () {
      firestore()
        .collection('times')
        .where('org', '==', sessionStorage.getItem('org'))
        .orderBy('date', 'desc')
        .limit(5)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let time = {
              date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
              description: doc.data().description,
              jobNum: doc.data().jobNum,
              employee: doc.data().employee,
              hours: doc.data().hours,
            };
            this.recentTimes.push(time);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMonthlyTotals: async function () {
      //this month
      //we will be getting the monthly total and we are also going to ge the totals for the top three jobs.
      await firestore()
        .collection('times')
        .where('date', '<=', new Date(moment().endOf(`${this.dateSelected}`)))
        .where('date', '>=', new Date(moment().startOf(`${this.dateSelected}`)))
        .where('org', '==', sessionStorage.getItem('org'))
        .get()
        .then(async (querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (
              !isNaN(doc.data().hours) &&
              !isNaN(doc.data().rate) &&
              doc.data().hours != null &&
              doc.data().rate != null
            ) {
              let lineTotal =
                Number(doc.data().hours) * Number(doc.data().rate);
              this.earningsTotal += lineTotal;

              //add the time to the totalTimes collection, so we can sort it by job after.
              let time = {
                customer: doc.data().customer ? doc.data().customer : '',
                jobNum: doc.data().jobNum,
                total: Number(doc.data().hours) * Number(doc.data().rate),
                hours: doc.data().hours,
                date: doc.data().date.toDate(),
                billable: doc.data().billable,
                employeeID: doc.data().user,
                overtime: doc.data().overtime,
              };
              this.allTimes.push(time);

              //push the jobs into a collection so we have a unique list of all jobs that have time in them for the current month.
              if (
                this.jobTypesCollection.findIndex(
                  (o) => o.jobNum == doc.data().jobNum
                ) == -1
              ) {
                this.jobTypesCollection.push({
                  jobNum: doc.data().jobNum,
                });
              }
            }
          });
          this.getJobTypes();
          this.getTopJobs();
          // this.getBillableTimes();
        })
        .catch((err) => {
          console.log(err);
        });
      //last month
      // let lastMonthTotal = 0;
      // await firestore()
      //   .collection('times')
      //   .where(
      //     'date',
      //     '<=',
      //     new Date(
      //       moment()
      //         .add(-1, `${this.dateSelected}`)
      //         .endOf(`${this.dateSelected}`)
      //     )
      //   )
      //   .where(
      //     'date',
      //     '>=',
      //     new Date(
      //       moment()
      //         .add(-1, `${this.dateSelected}`)
      //         .startOf(`${this.dateSelected}`)
      //     )
      //   )
      //   .where('org', '==', sessionStorage.getItem('org'))
      //   .get()
      //   .then((querySnapshot) => {
      //     querySnapshot.forEach((doc) => {
      //       if (
      //         !isNaN(doc.data().hours) &&
      //         !isNaN(doc.data().rate) &&
      //         doc.data().hours != null &&
      //         doc.data().rate != null
      //       ) {
      //         lastMonthTotal +=
      //           Number(doc.data().hours) * Number(doc.data().rate);
      //       }
      //     });
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });

      // //divide by zero check
      // if (lastMonthTotal !== 0) {
      //   this.earningsDifference = (this.earningsTotal / lastMonthTotal).toFixed(
      //     2
      //   );
      // } else {
      //   this.earningsDifference = 1;
      // }
      this.getTotalAndAverageHours();
    },
    goToJob: function (job) {
      this.$router.push({
        path: `/production/jobs/jobDetails/${job}`,
      });
    },
    getTopJobs: function () {
      //once all of the jobs are added to the collection, we will aggregate all of the times by jobNum and get totals.
      this.allTimes.sort(function compare(a, b) {
        //this is a custom sort function stolen off of SO.
        if (a.jobNum < b.jobNum) {
          return -1;
        }
        if (a.jobNum > b.jobNum) {
          return 1;
        }
        return 0;
      });

      //start collecting totals from the jobs. We will itterate the collection of times.
      let previousJobNum = null;
      this.allTimes.forEach((time) => {
        //check to see if this is a new job id.
        if (time.jobNum != previousJobNum) {
          //set the new job num, create the new job in the collection
          previousJobNum = time.jobNum;
          this.topJobsEarnings.push({
            customer: time.customer,
            jobNum: previousJobNum,
            total: time.total,
          });
        } else {
          //add the time to the job
          let index = this.topJobsEarnings.findIndex(
            (o) => o.jobNum == previousJobNum
          );
          this.topJobsEarnings[index].total += time.total;
        }
      });
      //sort the array to get the top three jobs.
      this.topJobsEarnings.sort(function compare(a, b) {
        //this is a custom sort function stolen off of SO.
        if (a.total < b.total) {
          return 1;
        }
        if (a.total > b.total) {
          return -1;
        }
        return 0;
      });
    },
    getTotalAndAverageHours: function () {
      let totalHours = 0;
      let dayCollection = [];
      this.allTimes.forEach((time) => {
        if (!isNaN(time.hours)) {
          totalHours += Number(time.hours);
        }
        //if the time is not in the local collection, we will add it. If not, go onto the next time.
        if (!dayCollection.includes(moment(time.date).format('MMM DD, YY'))) {
          dayCollection.push(moment(time.date).format('MMM DD, YY'));
        }
      });

      this.averageHours = (totalHours / dayCollection.length).toFixed(2);
      if (isNaN(this.averageHours)) {
        this.averageHours = 0;
      }
      this.totalHours = totalHours;
    },
    getNewJobs: async function () {
      await firestore()
        .collection('jobs')
        .where('date', '<=', new Date(moment().endOf('week')))
        .where('date', '>=', new Date(moment().startOf('week')))
        .where('org', '==', sessionStorage.getItem('org'))
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.allJobs.push({
              jobNum: doc.data().jobNum,
            });
            this.newJobs = this.allJobs.length;
          });
        })
        .catch((err) => {
          console.log(`Error getting new jobs: ${err}`);
        });
    },
    getJobsWithInvoiceRevenueCalculations: async function () {
      //we will retrieve every job that has invoices as the revenue calculation, and then get the times, products, and procurements for that job,
      //which we will send to the RevenueChart component, so we can calculate the expense, revenue, and profit of the job.
      try {
        (this.jobsWithInvoiceCalculations = []),
          (this.jobsWithInvoiceCalculationsTotals = {
            revenue: 0,
            invoiced: 0,
          });
        //TODO: eventually need to change this to getting all incomplete jobs, but need to wait until the new changes
        //TODO: in the create job page that set every new job complete:false to take effect.
        await firestore()
          .collection('jobs')
          .where('org', '==', sessionStorage.getItem('org'))
          .where('jobRevenueCalculations', '==', 'invoices')
          .get()
          .then((querySnapshot) => {
            let promises = [];
            querySnapshot.forEach(async (doc) => {
              //push the job to the array along with the invoices. Create fields for the times, products, and procurements, so we can get those separately for each job.
              this.jobsWithInvoiceCalculations.push({
                jobNum: doc.data().jobNum,
                jobType: doc.data().jobType ? doc.data().jobType : null,
                jobQuote: doc.data().jobQuote ? doc.data().jobQuote : null,
                invoices:
                  doc.data().invoices != undefined ? doc.data().invoices : [],
                times: [],
                products: [],
                procurements: [],
              });

              //we are pushing the promises into an array, so we can wait for the products and tiems to fully load before be render the revenuechart component.
              //without doing this, we weren't getting all of the data in time to the component, and the calculations were wrong.

              //get the times for the job.
              promises.push(this.getJobSpecificTimes(doc.data().jobNum));
              //get the products for the job
              promises.push(
                this.getJobSpecificBillableProducts(doc.data().jobNum)
              );
              //loop the invoices and start appending an invoicing total.
              if (doc.data().invoices) {
                doc.data().invoices.forEach((invoice) => {
                  this.jobsWithInvoiceCalculationsTotals.invoiced += Number(
                    invoice.amount
                  );
                });
              }
            });

            //once we have collected all of the promises, then we can execute them all at one.
            Promise.all(promises)
              .then(() => {
                this.loadingJobSpecificData = false;
              })
              .catch((err) => {
                console.log(err);
                Vue.$toast.open({
                  message:
                    'Error resolving promises in amount to be invoiced function.',
                  type: 'error',
                  duration: 4000,
                  position: 'top-right',
                });
              });
          })
          .catch((err) => {
            console.log(`Error getting jobs: ${err}`);
          });
      } catch (err) {
        Vue.$toast.open({
          message: 'Error gettting jobs.',
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
    getJobSpecificTimes: async function (jobNum) {
      try {
        //get the index of the job in the invoice jobs array.
        let tempIndex = this.jobsWithInvoiceCalculations.findIndex(
          (o) => o.jobNum == jobNum
        );
        //get the chargeable time for the job
        await firestore()
          .collection('times')
          .where('jobNum', '==', Number(jobNum))
          .where('org', '==', sessionStorage.getItem('org'))
          .orderBy('date', 'asc')
          .get()
          .then((timesSnapShot) => {
            let tempArg = [];
            timesSnapShot.forEach((time) => {
              let timeObj = {};
              timeObj.edit = time.id;
              timeObj.approved = time.data().approved;
              timeObj.approvedBy = time.data().approvedBy;
              timeObj.approvedTime = time.data().approvedTime;
              timeObj.billable = time.data().billable;
              timeObj.billableApprovedBy = time.data().billableApprovedBy;
              timeObj.billableApprovedTime = time.data().billableApprovedTime;
              timeObj.uid = time.data().user;
              timeObj.overtime = time.data().overtime
                ? time.data().overtime
                : false;
              timeObj.travelTime = time.data().travelTime
                ? time.data().travelTime
                : false;

              timeObj.rate = time.data().rate;
              timeObj.hours = time.data().hours;

              //add the line total.
              timeObj.lineTotal =
                timeObj.rate != undefined
                  ? (Number(timeObj.rate) * Number(timeObj.hours)).toFixed(2)
                  : 0;

              tempArg.push(timeObj);
            });
            this.jobsWithInvoiceCalculations[tempIndex].times = tempArg;
          })
          .catch((err) => {
            console.log(`Error getting times ${err}`);
            Vue.$toast.open({
              message: `Error gettting times for Job: ${jobNum}`,
              type: 'error',
              duration: 4000,
              position: 'top-right',
            });
          });
      } catch (err) {
        console.log(err);
        Vue.$toast.open({
          message: `Error gettting times for Job: ${jobNum}`,
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
    getJobSpecificBillableProducts: async function (jobNum) {
      try {
        //get the index of the job in the invoice jobs array.
        let tempIndex = this.jobsWithInvoiceCalculations.findIndex(
          (o) => o.jobNum == jobNum
        );
        //get the chargeable product for the job
        await firestore()
          .collection('billableProducts')
          .where('jobNum', '==', Number(jobNum))
          .where('org', '==', sessionStorage.getItem('org'))
          .orderBy('date', 'asc')
          .get()
          .then((productSnapShot) => {
            let tempArg = [];
            productSnapShot.forEach((product) => {
              let productObj = {};
              productObj.edit = product.id;
              productObj.approved = product.data().approved;
              productObj.approvedBy = product.data().approvedBy;
              productObj.approvedTime = product.data().approvedTime;
              productObj.billable = product.data().billable
                ? product.data().billable
                : false;
              productObj.billableApprovedBy = product.data().billableApprovedBy;
              productObj.billableApprovedTime =
                product.data().billableApprovedTime;
              productObj.user = product.data()['user'].name;
              //loop through the dynamic fields and get the values.
              productObj.rate = product.data().rate;
              productObj.quantity = product.data().quantity;
              productObj.price = product.data().price
                ? product.data().price
                : 0;

              //add the line total.
              productObj.lineTotal =
                productObj.rate != undefined
                  ? (
                      Number(productObj.rate) * Number(productObj.quantity)
                    ).toFixed(2)
                  : 0;

              tempArg.push(productObj);
            });
            this.jobsWithInvoiceCalculations[tempIndex].products = tempArg;
          })
          .catch((err) => {
            console.log(`Error getting products ${err}`);
            Vue.$toast.open({
              message: `Error gettting products for Job: ${jobNum}`,
              type: 'error',
              duration: 4000,
              position: 'top-right',
            });
          });
      } catch (err) {
        console.log(err);
        Vue.$toast.open({
          message: `Error gettting products for Job: ${jobNum}`,
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
    getBillableTimes: function () {
      //we will only add the revenue for the times that are on the Times x Materials job type, not the fixed rate jobs.

      //get all of the jobs that are not fixed rate.
      // let fixedRateJobs = this.jobTypesCollection.filter(
      //   (job) => job.type == 'Quoted (Fixed Rate)'
      // );

      //filter out all times so we only get the billable times and the times from the non quotes jobs.
      this.billableTimes = this.allTimes.filter(
        (time) => time.billable !== true
        // &&
        // fixedRateJobs.some((o) => o.jobNum != time.jobNum)
      );

      //we gave the earnings component a key so we could manually increment it here so the child componnet would redender.
      //I was running into some weird reactivity issue with this.
      // this.earningsKey++;
    },
    getProducts: async function () {
      await firestore()
        .collection('billableProducts')
        .where('date', '<=', new Date(moment().endOf(`${this.dateSelected}`)))
        .where('date', '>=', new Date(moment().startOf(`${this.dateSelected}`)))
        .where('org', '==', sessionStorage.getItem('org'))
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.allProducts.push(doc.data());
          });
        });

      //get all of the jobs that are not fixed rate.
      // let fixedRateJobs = this.jobTypesCollection.filter(
      //   (job) => job.type == 'Quoted (Fixed Rate)'
      // );

      //filter out all products so we only get the billable products and the products from the non quotes jobs.
      this.billableProducts = this.allProducts.filter(
        (product) => product.billable !== true
        // &&
        // fixedRateJobs.some((o) => o.jobNum != product.jobNum)
      );
      // this.earningsKey++;
    },
    getProcurements: async function () {
      await firestore()
        .collection('procurements')
        .where('date', '<=', new Date(moment().endOf(`${this.dateSelected}`)))
        .where('date', '>=', new Date(moment().startOf(`${this.dateSelected}`)))
        .where('org', '==', sessionStorage.getItem('org'))
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.allProcurements.push(doc.data());
          });
        });

      //get all of the jobs that are not fixed rate.
      // let fixedRateJobs = this.jobTypesCollection.filter(
      //   (job) => job.type == 'Quoted (Fixed Rate)'
      // );

      this.billableProcurements = this.allProcurements.filter((procurement) => {
        if (
          procurement.billable
          // &&
          // fixedRateJobs.some((o) => o.jobNum != procurement.jobNum)
        ) {
          return procurement.billable.value !== true;
        } else {
          // } else if (fixedRateJobs.some((o) => o.jobNum != procurement.jobNum)) {
          return true;
        }
      });
      this.loadedFlag = true;

      // this.earningsKey++;
    },
    getJobTypes: async function () {
      //loop the jobs and find out which ones are fixed rate jobs.
      for (const job of this.jobTypesCollection) {
        await firestore()
          .collection('jobs')
          .where('jobNum', '==', job.jobNum)
          .where('org', '==', sessionStorage.getItem('org'))
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((jobDoc) => {
              job['type'] =
                jobDoc.data().jobType != undefined
                  ? jobDoc.data().jobType
                  : 'Time x Material';
              job['date'] = jobDoc.data().date.toDate();
              job['quote'] =
                jobDoc.data().jobQuote != undefined
                  ? jobDoc.data().jobQuote
                  : null;
            });
          })
          .catch((err) => {
            console.log(`Error getting job type: ${err}`);
          });
      }

      this.getProducts();
      this.getProcurements();
      this.getBillableTimes();
      this.getQuotedJobRevenue();
    },
    getQuotedJobRevenue: function () {
      //filter the jobs array so we only have the fixed rate jobs for the current month.
      this.fixedRateJobs = this.jobTypesCollection.filter(
        (job) =>
          job.type == 'Quoted (Fixed Rate)' &&
          moment(job.date).month() == moment().month()
      );

      //itterate all of the fixed rate jobs to see is
      this.fixedRateJobs.forEach((job) => {
        this.fixedRateJobRevenue += Number(job.quote);
      });
    },
    revenueCalculated: function (revenueSummary, totalRevenue, jobNum) {
      //this is emitted from the revenuechart component. It will provide us the total revenue numbers.

      //revenue will count to labour budget if labour is set to billable rate and the type is dollar amount
      //revenue will always count to products budget
      //revenue will cound to procurement items budget if the unit of measure is set to marked-up amount.

      //check to see if the returned jobnumber is a fixed rate job.
      if (
        this.jobsWithInvoiceCalculations.find((o) => o.jobNum == jobNum)
          .jobType === 'Quoted (Fixed Rate)'
      ) {
        //this is a fixed rate job, just append the quoted amount here.
        this.jobsWithInvoiceCalculationsTotals.revenue += Number(
          this.jobsWithInvoiceCalculations.find((o) => o.jobNum == jobNum)
            .jobQuote
        );
      } else {
        //this is a regular job. Append the returned revenue amount here.
        this.jobsWithInvoiceCalculationsTotals.revenue += totalRevenue;
      }
    },
    changeDateSelection: function () {
      //reset all variables so we can get fresh numbers.
      this.resetData();
      //when the date selection in the dropdown changes, we need to recall all of the calculations.
      this.earningsMonth =
        this.dateSelected === 'year'
          ? moment().format('YYYY')
          : moment().format('MMMM');

      this.getRecentTimes();
      this.getMonthlyTotals();
    },
    resetData: function () {
      this.loadedFlag = false;
      this.earningsTotal = 0;
      this.sumHoursTotal = 0;
      this.earningsDifference = 0;
      this.allJobs = [];
      this.billableProducts = [];
      this.billableTimes = [];
      this.billableProcurements = [];
      this.totalHours = 0;
      this.averageHours = 0;
      this.jobTypesCollection = [];
      this.earningsKey = 0;
      this.fixedRateJobRevenue = 0;
      this.fixedRateJobs = [];
      this.recentTimes = [];
      this.topJobsEarnings = [];
      this.allProducts = [];
      this.allProcurements = [];
      this.allTimes = [];
    },

    // testSendBillingReport: function () {
    //   let request = {};
    //   axios
    //     .get(
    //       'http://localhost:5000/kali-45420/us-central1/testDailyIssuesReport',
    //       {
    //         params: {
    //           request,
    //         },
    //       }
    //     )
    //     .then((response) => {
    //       if (response.status == 200) {
    //         console.log('report sent!');
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(`Error calling the add user function: ${err}`);
    //       console.log(err);
    //     });
    // },
    // testSendWeeklyWorkOrderReport: function(){
    //   let request = {
    //       uid: `done`,
    //     };
    //     axios
    //       .get(
    //         'http://localhost:5000/kali-45420/us-central1/sendWeeklyWorkOrderReport',
    //         {params: {
    //             request,
    //           },}
    //       )
    //       .then((response) => {
    //         if (response.status == 200) {
    //           console.log("report sent!")
    //         }
    //       })
    //       .catch((err) => {
    //         console.log(`Error calling the work order report functions ${err}`);
    //         console.log(err);
    //       });
    // },
  },
  mounted: function () {
    this.getRecentTimes();
    this.getMonthlyTotals();
    this.getNewJobs();
    this.getJobsWithInvoiceRevenueCalculations();
  },
};
</script>
